import { render, staticRenderFns } from "./PersonalSetting.vue?vue&type=template&id=2f942795&"
import script from "./PersonalSetting.vue?vue&type=script&lang=js&"
export * from "./PersonalSetting.vue?vue&type=script&lang=js&"
import style0 from "./PersonalSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports